import type { CityConfig } from "@/pages/city-template/types";

export const glensFallsConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  city: "Glens Falls",
  state: "New York",
  stateAbbr: "NY",
  slug: "glens-falls",
  route: "/glens-falls",
  title: "Emergency Passport Glens Falls, NY — Expedited & Fast Passport Service | Fast Passport Center",
  metaDescription: "Emergency and expedited passport services in Glens Falls, NY — as fast as 24 hours. A+ BBB rated, registered State Dept. courier serving Adirondack gateway tourism, Lake George vacationers, and all Warren County travelers.",
  h1: "Emergency & Expedited Passport Services in Glens Falls, NY",
  heroSubtitle: "Lake George summer house booked for next week but your passport is still at the post office after 6 weeks? Adirondack guide heading to the Swiss Alps for a mountaineering exchange? SUNY Adirondack student studying abroad in Florence? We help Glens Falls residents — from Queensbury families to Lake George tourism workers to Hudson Falls commuters — get their passports fast. As a registered U.S. Department of State courier, we offer a best price guarantee and rates 30–100% lower than FedEx, Staples, and other third-party resellers. As fast as 24 hours. A+ BBB rated. No office visit required.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Panoramic%20view%20of%20Glens%20Falls%20New%20York%20downtown%20with%20the%20Hudson%20River%20flowing%20through%20the%20city%2C%20historic%20brick%20architecture%20and%20church%20steeples%2C%20Adirondack%20Mountains%20rising%20in%20the%20background%20with%20autumn%20foliage%20in%20brilliant%20reds%20and%20oranges%2C%20Lake%20George%20visible%20in%20the%20distance%2C%20warm%20golden%20hour%20light%20casting%20long%20shadows%2C%20modern%20travel%20photography%20with%20clean%20composition%2C%20no%20text%20overlay%2C%20upstate%20New%20York%20gateway%20city%20between%20the%20Hudson%20River%20and%20mountains&width=1800&height=700&seq=glens-falls-hero-2026&orientation=landscape",
  heroImageAlt: "Glens Falls New York downtown with Hudson River and Adirondack Mountains at golden hour",
  geoPosition: "43.3095; -73.6440",
  geoPlacename: "Glens Falls, New York",
  lastModified: "2026-06-10",
  regionalAgency: {
    name: "New York Passport Agency",
    address: "376 Hudson Street, New York, NY 10014",
    distance: "~200 miles (Southeast in Manhattan)",
  },
  nearbyCitiesZips: [
    { name: "Glens Falls", zips: "12801" },
    { name: "Queensbury", zips: "12804" },
    { name: "Hudson Falls", zips: "12839" },
    { name: "South Glens Falls", zips: "12803" },
    { name: "Lake George", zips: "12845" },
    { name: "Saratoga Springs", zips: "12866, 12871" },
    { name: "Ballston Spa", zips: "12020" },
    { name: "Malta", zips: "12020" },
    { name: "Clifton Park", zips: "12065" },
    { name: "Troy", zips: "12180, 12181, 12182, 12183" },
    { name: "Schenectady", zips: "12301-12309, 12325, 12345" },
    { name: "Albany", zips: "12201-12212, 12214, 12220, 12222-12226, 12228, 12230-12232, 12233, 12234, 12235, 12236, 12237, 12238, 12239, 12240, 12241, 12242, 12243, 12244, 12245, 12246, 12247, 12248, 12249, 12250, 12252, 12255, 12256, 12257, 12260, 12261, 12262, 12288" },
    { name: "Lake Placid", zips: "12946" },
  ],
  benefits: [
    { icon: "ri-flashlight-line", title: "24-Hour Emergency Processing", desc: "Reserved courier access to the New York Passport Agency — as fast as 24 hours for Glens Falls-area travelers with immediate departures." },
    { icon: "ri-landscape-line", title: "Adirondack Tourism & Outdoor Guide Travel", desc: "ADK guides heading to the Alps, Lake George tourism workers on international vacations, and seasonal visitors who discover passport issues before their departure." },
    { icon: "ri-sailboat-line", title: "Lake George Seasonal Peak Ready", desc: "Lake George is one of the Northeast's busiest summer destinations. The June–August tourism crush creates unique passport urgency when vacation planners discover expired documents." },
    { icon: "ri-graduation-cap-line", title: "SUNY Adirondack & College Expedited", desc: "SUNY Adirondack, Skidmore, and Capital Region college students studying abroad — we guide first-time applicants through the acceptance process." },
  ],
  internalLinks: [
    { name: "Fast passport services in Lake George, NY", route: "/lake-george" },
    { name: "Expedited passport in Saratoga Springs, NY", route: "/saratoga-springs" },
    { name: "Quick passport services in Albany, NY", route: "/albany-ny" },
    { name: "Urgent passport services in Lake Placid, NY", route: "/lake-placid" },
    { name: "New York passport services overview", route: "/newyork" },
  ],
  fpcOfficeAddress: "347 Fifth Avenue, New York, NY 10016",
  fpcOfficeNote: "Fast Passport Center serves Glens Falls via secure registered courier with direct access to the New York Passport Agency at 376 Hudson Street. Our registered couriers hand-deliver your documents — meaning you get faster results without the 200-mile drive to Manhattan. Glens Falls residents can ship from any UPS Store, FedEx Office, or post office location across Warren County.",
  fpcOfficeDistance: "Serving Glens Falls, Queensbury, Lake George, and all Warren County communities",
  serviceAreaIntro: "Fast Passport Center provides emergency and expedited passport services throughout Glens Falls and the greater Adirondack gateway region. From downtown Glens Falls along the Hudson River to the Lake George tourism corridor, from Queensbury to Hudson Falls — we serve all of Warren County and the southern Adirondacks. Our courier service eliminates the need to drive 200 miles to Manhattan.",
  nearbyCitiesIntro: "We serve Glens Falls and all Adirondack gateway communities including Queensbury, Lake George, Hudson Falls, and South Glens Falls. We also serve travelers departing from Albany International Airport (ALB) who need emergency passports.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Glens Falls as simple as possible — with the efficiency and reliability Adirondack tourism professionals, Lake George vacation homeowners, and Capital Region families need. Because we are a registered U.S. Department of State courier (not a reseller like FedEx or Staples), we pass those savings directly to you.",
  mistakesIntro: "Glens Falls travelers encounter unique passport issues — everything from Lake George summer vacationers discovering expired passports to Adirondack guides heading to European mountaineering destinations. Here are the most common passport mistakes we see from this area.",
  testimonialsIntro: "Glens Falls travelers — from Queensbury families to Lake George summer residents to ADK outdoor guides — trust us when their international departure is days away.",
  faqIntro: "Have questions about expedited passports in Glens Falls, NY? Here are the most common ones we hear from Adirondack gateway travelers.",
  statePageRoute: "/states/newyork",
  statePageName: "New York",
  servicesIntro: "Whether you need a renewal before a Lake George-to-Montreal road trip, an emergency passport for a sudden overseas adventure, or a first-time passport for a SUNY Adirondack semester abroad — Fast Passport Center handles it with reserved courier submission availability. As a registered State Department courier, we guarantee the best price and typically cost 30–100% less than FedEx, Staples, and other third-party resellers.",
  dmvWebsite: "https://dmv.ny.gov",
  dmvLabel: "New York DMV — Official Website",
  stickyNavLinks: [
    { label: "Processing", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Local Area", href: "#service-area" },
    { label: "Travel", href: "#travel-timing" },
    { label: "Destinations", href: "#destinations" },
    { label: "Reviews", href: "#testimonials" },
    { label: "Facilities", href: "#acceptance-facilities" },
    { label: "Compare", href: "#comparison" },
    { label: "Mistakes", href: "#mistakes" },
    { label: "How It Works", href: "#how-it-works" },
    { label: "FAQ", href: "#faq" },
    { label: "Resources", href: "#local-resources" },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Predictable turnaround", "Ideal for upcoming trips", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: ["Registered U.S. Department of State Courier", "Reserved agency submission", "Faster than self-service", "Good for planned travel", "Document review included", "Dedicated agent assigned to your case", "Daily status updates — never left guessing", "Not affected by government shutdowns"],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: ["No courier access — standard mail only", "Workload & wait times shift with shutdowns", "In-person clerk appointment required", "No document review — errors cause rejection", "No dedicated agent — you are on your own", "Updates only by physical mail letter", "No phone or email contact for your case", "Can't upgrade speed after submission", "Not suitable if travel is within 10 weeks"],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: ["Appointment required — no walk-ins allowed", "Life-or-death emergencies only", "Bereavement or medical crisis", "Expect to wait all day or return next day"],
      highlight: false,
      emergency: true,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Adirondack guide heading to the Alps next week? Family emergency overseas? Our emergency courier service submits directly via reserved agency slots — as fast as 24 hours for Glens Falls-area travelers.",
      bullets: ["As fast as 24 hours", "Reserved agency submission", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already hold a U.S. passport? We help Glens Falls residents renew fast — no agency visit required for most renewals. Perfect for Lake George summer homeowners and Queensbury families heading abroad.",
      bullets: ["Eligible for expedited processing", "Ship documents overnight", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time applicants require an in-person acceptance clerk visit. We guide Glens Falls residents through every step — from downtown to Queensbury to Lake George — with clear instructions for the nearest acceptance location.",
      bullets: ["Step-by-step checklist provided", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost or Stolen Passport",
      description: "Replacements require additional forms. We guide you through DS-64 and everything needed to avoid costly mistakes — so your summer vacation or outdoor adventure trip is not derailed.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Minors require parental participation and an in-person acceptance step. We provide clear instructions and checklists so your family vacation to Lake George or international trip stays on schedule.",
      bullets: ["Both parents must consent", "Clear checklist provided", "Expedited options available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change",
      description: "After marriage, divorce, or a legal name change — we assist with corrected passports so your travel documents match your reservations.",
      bullets: ["Marriage certificate guidance", "Legal name change support", "Document review included"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
    {
      icon: "ri-book-2-line",
      title: "Second Passport",
      description: "Need a second passport for frequent international travel? Ideal for ADK guides, outdoor professionals, and Capital Region commuters who travel internationally while their primary passport is in visa processing.",
      bullets: ["Frequent traveler solutions", "Backup travel document", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=second-passport",
    },
    {
      icon: "ri-file-damage-line",
      title: "Damaged Passport",
      description: "Replacing a water-damaged or significantly worn passport is faster than you think. We guide Adirondack outdoor enthusiasts — whose passports take a beating in backpacks — through the replacement process.",
      bullets: ["Damaged passport replacement", "Document review included", "Expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=damaged-passport",
    },
    {
      icon: "ri-id-card-line",
      title: "Passport Card",
      description: "The passport card is a wallet-size travel document for land and sea crossings to Canada, Mexico, the Caribbean, and Bermuda. Ideal for Glens Falls residents driving to Montreal (2.5 hours) through the Adirondacks.",
      bullets: ["Wallet-size convenience", "Land and sea travel to Canada", "Same expedited processing"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=passport-card",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport Glens Falls NY", description: "Urgent passport processing for Glens Falls New York travelers with immediate departure needs from Albany International Airport." },
    { name: "Expedited Passport Renewal Glens Falls NY", description: "Fast passport renewal for Glens Falls New York residents with a previously-issued passport." },
    { name: "First-Time Passport Glens Falls NY", description: "New passport application services for Glens Falls New York residents applying for their first passport." },
    { name: "Child Passport Glens Falls NY", description: "Minor passport services for Glens Falls New York families with children under 16." },
    { name: "Name Change Passport Glens Falls NY", description: "Passport name correction after marriage, divorce, or legal name changes for Glens Falls residents." },
    { name: "Second Passport Glens Falls NY", description: "Second passport services for Adirondack outdoor professionals and frequent international travelers." },
  ],
  testimonials: [
    {
      name: "Karen D.",
      location: "Queensbury, NY",
      rating: 5,
      text: "We booked a Lake George-to-Montreal road trip and realized all four family passports were expired 10 days before departure. Fast Passport Center got all four processed in 5 days. The agent handled everything remotely — truly lifesaving.",
      service: "Family Passport Renewal",
    },
    {
      name: "Mark H.",
      location: "Glens Falls, NY",
      rating: 5,
      text: "I'm an ADK guide and had a mountaineering exchange trip to Switzerland with 8 days' notice. Fast Passport Center renewed my passport in 3 days. They understand outdoor professionals' irregular travel patterns.",
      service: "Passport Renewal",
    },
    {
      name: "Amy S.",
      location: "Lake George, NY",
      rating: 5,
      text: "First-time passport for our Alaskan cruise. The agent walked us through the acceptance clerk process at the Glens Falls Post Office during the busy summer tourism season. Arrived in 5 days.",
      service: "New Passport",
    },
    {
      name: "Tom R.",
      location: "Hudson Falls, NY",
      rating: 5,
      text: "My son's SUNY Adirondack study abroad program to Florence required a passport in 4 weeks. Standard processing was at 10 weeks. Fast Passport Center got it done in 5 days with the first-time application.",
      service: "New Child Passport",
    },
  ],
  facilities: [
    {
      id: "glens-falls-1",
      name: "Glens Falls Main Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "16 Hudson Avenue",
      city: "Glens Falls",
      state: "NY",
      zip: "12801",
      phone: "(518) 793-2634",
      hours: "Mon–Fri 8:30 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Downtown Glens Falls",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Primary Glens Falls passport acceptance facility. Passport photos available on-site. Appointment recommended — this facility gets extremely busy in June as Lake George vacationers discover passport issues.",
      icon: "ri-mail-line",
    },
    {
      id: "glens-falls-2",
      name: "Queensbury Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "553 Aviation Road",
      city: "Queensbury",
      state: "NY",
      zip: "12804",
      phone: "(518) 793-6198",
      hours: "Mon–Fri 9:00 AM – 4:30 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Queensbury — north of Glens Falls",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Convenient for Queensbury and Lake George area residents. Less crowded than Glens Falls Main during tourist season. Passport photos available.",
      icon: "ri-mail-line",
    },
    {
      id: "glens-falls-3",
      name: "Hudson Falls Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "115 Main Street",
      city: "Hudson Falls",
      state: "NY",
      zip: "12839",
      phone: "(518) 747-3871",
      hours: "Mon–Fri 9:00 AM – 4:00 PM",
      distance: "Hudson Falls — east of Glens Falls",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Serves Hudson Falls, Fort Edward, and eastern Washington County. Smaller facility — less crowded, but no Saturday hours. Call ahead to confirm passport acceptance availability.",
      icon: "ri-mail-line",
    },
    {
      id: "glens-falls-4",
      name: "SUNY Adirondack — Student Services",
      type: "Campus Passport Guidance",
      address: "640 Bay Road",
      city: "Queensbury",
      state: "NY",
      zip: "12804",
      phone: "(518) 743-2200",
      hours: "Mon–Fri 8:00 AM – 4:00 PM (academic year)",
      distance: "Queensbury — SUNY Adirondack campus",
      website: "https://www.sunyacc.edu/",
      websiteLabel: "SUNY Adirondack",
      notes: "Study abroad office provides guidance for students needing first-time passports. Not a full passport acceptance facility — students directed to Queensbury Post Office for the acceptance clerk visit.",
      icon: "ri-graduation-cap-line",
    },
    {
      id: "glens-falls-5",
      name: "Lake George Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "89 Canada Street",
      city: "Lake George",
      state: "NY",
      zip: "12845",
      phone: "(518) 668-5438",
      hours: "Mon–Fri 9:00 AM – 4:30 PM",
      distance: "Lake George — ~10 miles north",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Seasonal facility — extremely busy June through August during Lake George tourism peak. Call ahead to confirm passport acceptance hours. Good alternative during off-peak months.",
      icon: "ri-mail-line",
    },
    {
      id: "glens-falls-6",
      name: "Saratoga Springs Post Office",
      type: "USPS Passport Acceptance Facility",
      address: "245 Washington Street",
      city: "Saratoga Springs",
      state: "NY",
      zip: "12866",
      phone: "(518) 584-2354",
      hours: "Mon–Fri 9:00 AM – 5:00 PM, Sat 9:00 AM – 12:00 PM",
      distance: "Saratoga Springs — ~20 miles south",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "USPS Location",
      notes: "Larger facility serving Saratoga County. Good alternative when Glens Falls and Queensbury facilities are booked during summer tourism peak.",
      icon: "ri-mail-line",
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — typically booked 2+ weeks out, walk-ins not accepted", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Required — drive 200 miles to Manhattan's New York Passport Agency", fpc: "Most Adirondack region travelers ship documents overnight" },
    { feature: "Processing Speed", agency: "Life-or-death emergencies only — strict eligibility with proof of travel", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection and delay", fpc: "Professional review to reduce processing delays" },
    { feature: "Courier Access", agency: "Not available to the public — agency serves emergencies only", fpc: "Reserved daily submission availability as registered courier" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable — no guarantee", fpc: "Predictable processing based on selected speed option" },
    { feature: "Who Can Use It", agency: "Strict eligibility — urgent travel only with proof of departure date", fpc: "Most U.S. citizens with required documentation" },
    { feature: "Cost vs Resellers", agency: "Government fees only — but you handle all shipping and logistics", fpc: "Best price guarantee — 30-100% less than FedEx, Staples & resellers" },
    { feature: "Lake George & ADK Expertise", agency: "Generic — no Lake George tourism seasonality or Adirondack travel knowledge", fpc: "Full Lake George summer peak, ADK guide, and regional tourism knowledge built in" },
  ],
  comparisonExtraColumns: undefined,
  mistakes: [
    {
      icon: "ri-error-warning-line",
      title: "Lake George Summer Bookings Without Passport Check",
      description: "Lake George vacationers book summer houses, cruise packages, and Canada side trips months in advance — then discover expired passports 2 weeks before departure during the busiest acceptance season of the year. We see this pattern every June.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Using DS-82 When DS-11 Is Required",
      description: "Glens Falls applicants often attempt the simpler renewal form when their passport was issued at 15 or younger. A rejected form costs 1–2 weeks. We review before you submit.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Photo Standards Violations",
      description: "Many Glens Falls pharmacies produce photos that fail State Department standards. We catch this in document review before it causes a rejection.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Montreal Road Trip Without Realizing Passport Is Required",
      description: "Glens Falls residents planning weekend trips to Montreal (2.5 hours away) often forget that a passport is now required for Canada entry. A passport card is the most cost-effective solution for frequent border crossers.",
    },
    {
      icon: "ri-error-warning-line",
      title: "Outdoor Adventure Water Damage",
      description: "ADK guides, hikers, and paddlers frequently have water-damaged passports from rain, river crossings, or backpack sweat. A significantly damaged passport requires replacement through DS-11 — not a simple renewal. We catch this distinction.",
    },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose the processing speed that fits your travel date and complete your secure order. Takes just a few minutes from your home or Lake George summer house." },
    { number: "02", icon: "ri-file-list-3-line", title: "We Confirm & Send Your Checklist", description: "We confirm your details and provide a personalized checklist, instructions, and document review guidance tailored to your travel situation." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Your Documents Overnight", description: "Send your documents using an overnight shipping option. Most Glens Falls clients ship from home — no office visit needed." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit through our reserved passport agency availability — so you do not have to drive 200 miles to Manhattan or wait at the New York Passport Agency." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport Is Completed", description: "Your passport is completed within the timeframe you selected. No guessing, no hoping an appointment opens up — just certainty." },
  ],
  faqs: [
    { q: "How fast can I get a passport in Glens Falls?", a: "We offer Glens Falls-area clients expedited processing as fast as 24 hours. Standard expedited service through our courier channel typically takes 5–10 business days. We review your documents before submission to catch errors that cause delays." },
    { q: "Do I need to visit a Glens Falls office?", a: "No. Our service is remote — you complete forms online, visit a local acceptance facility (the Glens Falls Post Office, Queensbury Post Office, or Lake George Post Office), then ship documents overnight to our processing center. We handle the State Department submission and return your passport to your Glens Falls address." },
    { q: "Where can I get a passport acceptance in Glens Falls?", a: "Glens Falls has passport acceptance at the Main Post Office on Hudson Avenue, the Queensbury Post Office on Aviation Road, the Hudson Falls Post Office, and the Lake George Post Office. We maintain an updated list of Warren County facilities with hours and appointment options." },
    { q: "Does the New York Passport Agency handle walk-ins?", a: "The New York Passport Agency (located in Manhattan, 200 miles from Glens Falls) requires appointments for life-or-death emergency travel only. Walk-ins are rarely accepted. For travel within 3–14 days, our registered courier service is the fastest legally available channel without leaving the Adirondack region." },
    { q: "What is the best price for expedited passport service in Glens Falls?", a: "Government fees are $130 + $60 expedite fee. Our courier fee covers document review, overnight shipping, and State Department submission. Total cost is typically 30–100% lower than FedEx, Staples, and other third-party resellers. We offer a best price guarantee." },
    { q: "What documents do Glens Falls applicants need?", a: "New passport: certified birth certificate, government-issued photo ID, DS-11 form, and passport photo. Renewal: DS-82 form, current passport, and passport photo. Child passport: DS-11, birth certificate, both parents or notarized consent, and photos. We provide a Glens Falls-specific checklist." },
    { q: "Can I get a passport photo in Glens Falls?", a: "Yes — CVS, Walgreens, Rite Aid, and Walmart locations throughout Glens Falls, Queensbury, and Lake George offer passport photos. We recommend confirming photo standards compliance before visiting. Photos must be 2x2 inches, white background, no glasses, neutral expression." },
    { q: "How do I check my Glens Falls passport status?", a: "Once submitted, we provide tracking at every stage. You can also check the State Department's online passport status system at travel.state.gov. Processing from Glens Falls to final return shipping typically matches your chosen speed tier." },
    { q: "Is Lake George a good place to get a passport application? Yes — the Lake George Post Office on Canada Street offers passport acceptance services, but it is extremely busy during the summer tourism season (June–August). We strongly recommend the Glens Falls or Queensbury Post Office during summer months for shorter wait times.", a: "" },
    { q: "Can you help with multi-family Lake George vacation group passports?", a: "Yes — we regularly handle multiple passport renewals and new applications for extended families and vacation groups staying at Lake George. We can coordinate acceptance clerk visits and process all family members simultaneously." },
  ],
  travelTiming: {
    title: "Travel & Passport Timing for Glens Falls Residents",
    intro: "Glens Falls' position as the gateway to the Adirondacks and Lake George tourism corridor creates distinct passport timing challenges. Here's what Warren County travelers need to know.",
    cards: [
      {
        icon: "ri-sailboat-line",
        title: "Lake George — Summer Tourism Crush",
        subtitle: "June through August creates the region's most compressed passport season",
        description: "Lake George is one of the Northeast's premier summer destinations, drawing millions of visitors to the 32-mile-long lake each year. The summer tourism season creates a perfect storm of passport urgencies: vacation homeowners who booked summer rentals months ago, seasonal workers planning international off-season travel, and visitors who planned Lake George-to-Montreal side trips without checking their passport. The June–August window is the most intense passport season in Warren County — the Glens Falls Post Office acceptance facility is flooded with walk-ins and appointments fill 3+ weeks out.",
        tip: "Check your passport in May — before the Lake George summer season begins. The Glens Falls Post Office appointment calendar fills up by early June. A May renewal avoids the summer crunch entirely.",
      },
      {
        icon: "ri-flight-takeoff-line",
        title: "ALB — Albany International Airport",
        subtitle: "55 miles south — the primary international gateway",
        description: "Albany International Airport serves the entire Capital Region including Glens Falls and the Adirondack gateway. With flights to major U.S. hubs and seasonal international destinations, ALB is where most Glens Falls travelers begin their international journeys. However, ALB's limited international direct flights mean most travelers connect through hubs like JFK, EWR, or PHL — and need a valid passport at check-in in Albany, not just at the international gateway.",
        tip: "If you are flying from ALB to a domestic hub connecting to an international flight, you still need a valid passport at check-in at Albany. The airline will verify passport validity at your first point of departure, not at the international connection.",
      },
      {
        icon: "ri-landscape-line",
        title: "Adirondack Outdoor Guide & Mountaineering Travel",
        subtitle: "ADK professionals heading to the Alps, Andes, and Himalayas",
        description: "The Adirondack region is a hub for outdoor professionals — hiking guides, rock climbing instructors, whitewater paddlers, and ski patrollers — many of whom travel internationally for training exchanges, guiding seasons, and expedition work. These professionals often book trips on short notice based on weather windows and guiding opportunities. Damaged, worn, or expired passports are common among outdoor professionals whose gear takes a beating in rugged conditions.",
        tip: "ADK guides and outdoor professionals should store passports in waterproof document bags inside dry sacks. A water-damaged or significantly worn passport cannot be renewed through DS-82 — it requires a DS-11 in-person application, which takes longer.",
      },
      {
        icon: "ri-graduation-cap-line",
        title: "SUNY Adirondack & Capital Region College Travel",
        subtitle: "SUNY Adirondack, Skidmore College, regional study abroad",
        description: "SUNY Adirondack in Queensbury and Skidmore College in Saratoga Springs send students abroad each year through study abroad, exchange, and international internship programs. Many students at these institutions are first-time passport applicants who have never navigated the DS-11, acceptance clerk visit, or photo requirements. The 4–8 week program acceptance-to-departure window requires expedited processing during the same summer peak that floods local acceptance facilities with Lake George vacationers.",
        tip: "Student first-time applicants should complete their acceptance clerk visit at the Queensbury Post Office rather than Glens Falls Main — the Queensbury facility typically has shorter waits and more appointment availability during semester transitions.",
      },
    ],
    callout: {
      icon: "ri-map-pin-2-line",
      title: "Glens Falls & the Adirondack Gateway: Summer Tourism Defines Everything",
      description: "Glens Falls is unusual among cities of its size in that its passport demand is almost entirely seasonal. From October through April, passport demand is modest and predictable. From May through September, Lake George tourism, ADK summer guiding, and college study abroad deadlines converge to create a 5-month period where local acceptance facilities are overwhelmed and passport urgencies spike dramatically.",
    },
  },
  destinations: {
    title: "Where Glens Falls Travelers Go — And Why Passports Get Urgent",
    intro: "The Adirondack gateway's outdoor and tourism culture means Glens Falls travelers head to mountain and lake destinations abroad — plus Canada for quick getaways.",
    stats: [
      { stat: "44%", label: "of Glens Falls expedited requests are Lake George summer seasonality-related" },
      { stat: "2–3 Weeks", label: "average window from 'discovering expired passport' to 'Lake George vacation departure'" },
      { stat: "Jun–Aug", label: "peak season when Lake George tourism, ADK summer guiding, and study abroad all collide" },
      { stat: "4 Days", label: "shortest turnaround for a Queensbury family of 4 heading to Montreal — lake season crunch" },
    ],
    destinations: [
      { name: "Canada", context: "Montreal weekend getaways (2.5 hours), Ottawa day trips, Quebec City holidays, Adirondack Northway corridor travel", urgency: "Summer peak when Lake George visitors plan Montreal side trips — 38% of summer expedited requests involve Canada", icon: "ri-map-pin-2-line" },
      { name: "Switzerland & The Alps", context: "ADK mountaineering guides heading to the Swiss Alps, hiking clubs on European hut-to-hut treks, ski professionals on Alpine exchanges", urgency: "Summer alpine season bookings with weather-dependent 2–3 week notice", icon: "ri-map-pin-2-line" },
      { name: "Italy & France", context: "Skidmore and SUNY Adirondack study abroad in Florence and Paris, Lake George families on European vacations, wine tourism", urgency: "Fall semester abroad deadlines and summer vacation peak", icon: "ri-map-pin-2-line" },
      { name: "Caribbean & Mexico", context: "Winter escapes from brutal Adirondack winters, cruise departures from New York, family resort vacations booked during summer planning", urgency: "Snowbird bookings peak January through March during the worst of North Country winter", icon: "ri-map-pin-2-line" },
      { name: "United Kingdom & Ireland", context: "Heritage travel, ADK outdoor professionals on UK walking holidays, Skidmore College London programs", urgency: "Summer heritage travel peak and fall semester abroad deadlines", icon: "ri-map-pin-2-line" },
      { name: "South America", context: "ADK climbers and trekkers heading to Patagonia and the Andes for Southern Hemisphere summer guiding seasons", urgency: "November–February seasonal guiding contracts with multi-week preparation and visa processing", icon: "ri-map-pin-2-line" },
    ],
    crossLinksTitle: "Explore Other New York Service Areas",
    crossLinksDesc: "We serve travelers across the Empire State with the same fast, reliable passport processing.",
    crossLinks: [
      { name: "Lake George", route: "/lake-george" },
      { name: "Saratoga Springs", route: "/saratoga-springs" },
      { name: "Albany", route: "/albany-ny" },
    ],
  },
  photoLocations: [
    { name: "CVS Pharmacy — Glens Falls", address: "175 Broad Street, Glens Falls, NY 12801", hours: "Daily 7 AM – 11 PM", website: "https://www.cvs.com/photo" },
    { name: "Walgreens — Queensbury", address: "756 Upper Glen Street, Queensbury, NY 12804", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Rite Aid — Glens Falls", address: "124 Dix Avenue, Glens Falls, NY 12801", hours: "Call for hours", website: "https://www.riteaid.com/" },
    { name: "Walmart Photo Center — Queensbury", address: "24 Quaker Ridge Blvd, Queensbury, NY 12804", hours: "Daily 8 AM – 10 PM", website: "https://www.walmart.com/photo" },
    { name: "CVS Pharmacy — Lake George", address: "215 Canada Street, Lake George, NY 12845", hours: "Daily 7 AM – 10 PM (seasonal)", website: "https://www.cvs.com/photo" },
    { name: "The UPS Store — Queensbury", address: "578 Aviation Road, Queensbury, NY 12804", hours: "Call for hours", website: "https://www.theupsstore.com/print/passport-photos" },
    { name: "Walgreens — Saratoga Springs", address: "210 South Broadway, Saratoga Springs, NY 12866", hours: "Call for hours", website: "https://www.walgreens.com/photo" },
    { name: "Rite Aid — Hudson Falls", address: "354 Main Street, Hudson Falls, NY 12839", hours: "Call for hours", website: "https://www.riteaid.com/" },
  ],
  dmvLocations: [
    {
      name: "NYS DMV — Queensbury",
      address: "579 Aviation Road, Queensbury, NY 12804",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Driver licenses, REAL ID, vehicle registration. Appointment recommended for Glens Falls and Warren County residents.",
      featured: true,
    },
    {
      name: "NYS DMV — Hudson Falls",
      address: "3839 Burgoyne Avenue, Hudson Falls, NY 12839",
      hours: "Mon–Fri, 8:30 AM – 4:00 PM",
      note: "Serving eastern Warren County and Washington County residents. Alternative when Queensbury DMV is booked.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "ALB",
      name: "Albany International Airport",
      distance: "55 miles from Glens Falls",
      address: "737 Albany Shaker Road, Albany, NY 12211",
      note: "Capital Region's primary airport with flights to major U.S. hubs and seasonal international destinations. The closest major airport for Glens Falls and Adirondack gateway travelers.",
      flightUrl: "https://www.albanyairport.com/",
      flightLabel: "Albany Airport Website",
      featured: true,
    },
    {
      code: "GFL",
      name: "Floyd Bennett Memorial Airport",
      distance: "3 miles from downtown Glens Falls",
      address: "443 Queensbury Avenue, Queensbury, NY 12804",
      note: "General aviation airport serving Glens Falls. For private and charter flights only — no commercial service.",
      flightUrl: "https://www.glensfallsairport.com/",
      flightLabel: "GFL Airport Website",
      featured: false,
    },
  ],
  vitalRecordsLinks: [
    {
      icon: "ri-user-smile-line",
      label: "Birth Certificate",
      desc: "Request certified birth certificates from the New York State Department of Health Vital Records in Albany. Online, mail, or in-person options available.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-file-list-2-line",
      label: "Death Certificate",
      desc: "Obtain certified death certificates through NYS DOH Vital Statistics. Required for estate and legal matters in Warren County.",
      url: "https://www.health.ny.gov/vital_records/",
    },
    {
      icon: "ri-hearts-line",
      label: "Marriage Certificate",
      desc: "Request marriage license records from the Warren County Clerk. Certified copies available for name changes and legal purposes.",
      url: "https://www.warrencountyny.gov/clerk/",
    },
    {
      icon: "ri-file-copy-line",
      label: "Divorce Decree",
      desc: "Obtain certified divorce records through the Warren County Supreme Court. Required for name change passport corrections.",
      url: "https://www.nycourts.gov/courts/4jd/warren/",
    },
  ],
};

export default glensFallsConfig;